var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "col-md-12",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.isFormValid,
                    callback: function($$v) {
                      _vm.isFormValid = $$v
                    },
                    expression: "isFormValid"
                  }
                },
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: "Información General" } },
                        [
                          _vm._t("prependInformacionGeneral"),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm12: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|max:80|CampoUnico",
                                    expression: "`required|max:80|CampoUnico`"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.sigla.label,
                                  "data-vv-name": _vm.formFields.sigla.id,
                                  id: _vm.formFields.sigla.id,
                                  counter: "80",
                                  disabled: _vm.isVerDetalle || _vm.isEditar,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.sigla.id
                                  ),
                                  "data-testid": _vm.testId + "--sigla"
                                },
                                model: {
                                  value: _vm.formFields.sigla.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formFields.sigla, "value", $$v)
                                  },
                                  expression: "formFields.sigla.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md12: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|max:80",
                                    expression: "'required|max:80'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.nombre.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.nombre.id
                                  ),
                                  "data-vv-name": _vm.formFields.nombre.id,
                                  "data-testid": _vm.testId + "--nombre",
                                  counter: 80,
                                  disabled: _vm.isVerDetalle
                                },
                                model: {
                                  value: _vm.formFields.nombre.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.nombre,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.nombre.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md12: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "max:200",
                                    expression: "'max:200'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.descripcion.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.descripcion.id
                                  ),
                                  "data-vv-name": _vm.formFields.descripcion.id,
                                  "data-testid": _vm.testId + "--descripcion",
                                  counter: 200,
                                  disabled: _vm.isVerDetalle
                                },
                                model: {
                                  value: _vm.formFields.descripcion.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.descripcion,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.descripcion.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        2
                      ),
                      _c("br")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }